<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-4">Sutarties dalykas</h3>
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page.sync="pageSize"
      :search="search"
      :page.sync="page"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button-prideti
            v-if="!isReadonlyForm"
            primary
            @click.native.stop="openDaiktas(null)"
          >
            Pridėti daiktą
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.dai_aprasymas`]="{ item }">
        <div class="text-cut-4">
          {{ item.dai_aprasymas }}
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @deleteItem="deleteItem(item)"
          @restoreItem="restoreItem(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-daiktas
      :key="modalDaiktasKey"
      :readonly="isReadonlyForm"
      v-model="showDaiktas"
      :daiktas="modalDaiktas"
      :daiktas-rusys="daiktas_rusys"
      @savedData="savedDaiktas"
    />
    <modal-delete
      title="Šalinti daiktą?"
      :text="
        `Ar norite pašalinti daiktą <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />

    <hipoteka-istorija duomenys="sutarties-dalykas" />

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button primary @click.native="checkErrors()" :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './../hipoteka/hipotekaMap'
import ModalDaiktas from '../modals/ModalDaiktas'
import ModalDelete from '../modals/ModalDelete'
import checkErrors from '../../mixins/checkErrors'
import rowClass from '../../mixins/rowClass'
import HipotekaIstorija from './../hipoteka/istorija/HipotekaIstorija'

export default {
  name: 'SutartisDaiktas',
  components: {
    ModalDaiktas,
    ModalDelete,
    HipotekaIstorija,
  },
  mixins: [checkErrors, rowClass],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      sutartis_daiktas: [],
      daiktas_rusys: [],
      modalDaiktasRefresh: 0,
      showDaiktas: false,
      modalDaiktas: {},
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    headers() {
      return [
        {
          text: 'Eil. Nr.',
          align: 'start',
          value: 'eil_nr',
        },
        {
          text: 'Daikto rūšis',
          align: 'start',
          value: 'dai_rusis',
        },
        {
          text: 'Daikto aprašymas',
          align: 'start',
          value: 'dai_aprasymas',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.sutartis_daiktas.map((item, index) => {
        item.eil_nr = index + 1

        item.canEdit = !item.deleted && !this.isReadonlyForm
        item.canView = !item.canEdit
        item.canDelete = !item.deleted && !this.isReadonlyForm
        item.canRestore = item.tevinis_id > 0 && (item.deleted || item.edited)
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    modalDaiktasKey() {
      return 'daiktas' + this.modalDaiktasRefresh
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/sutartisdaiktas`)
        .then(res => {
          this.sutartis_daiktas = res.data.sutartis_daiktas
          this.daiktas_rusys = res.data.rusys
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    editItem(item) {
      this.openDaiktas(item)
    },
    openDaiktas(item) {
      if (item) {
        this.modalDaiktas = {
          dai_id: item.dai_id,
          dai_rusis_kla_id: item.dai_rusis_kla_id,
          dai_aprasymas: item.dai_aprasymas,
        }
      } else {
        this.modalDaiktas = {}
      }

      this.modalDaiktasRefresh++
      this.showDaiktas = true
    },
    savedDaiktas(modalDaiktas) {
      this.loading = true

      let data = modalDaiktas
      data.obj_id = this.objektasID

      this.$axios
        .post(`objektas/${this.objektasID}/sutartisdaiktas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.dai_rusis
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`objektas/${this.objektasID}/sutartisdaiktas/${item.dai_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    restoreItem(item) {
      this.$axios
        .post(
          `objektas/${this.objektasID}/sutartisdaiktas/${item.dai_id}/restore`
        )
        .then(res => {
          this.getData()
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    getActiveClass(item) {
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.dragIcon {
  cursor: pointer;
}
</style>
